import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, getUTCTimeStamp, getUTCTimeStampp, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (!data || (typeof data === 'string' && data.includes('<html>'))) {
    throw {
      message: 'No Data.',
      code: 'SERVER_ERROR_500',
    }
  }
  if (isStatusOK(data) && data?.data?.responseStatus?.code === '000') {
    console.log('data at try block in responseParser getfavouriteTransaction', data)
    return data.data.responseObject
  } else {
    console.log('data at catch block in responseParser getfavouriteTransaction', data.data)
    throw getNetworkResponseError(data?.data)
  }
}

export const getOrderHistoryBCApi = (tokens: any, body: any) => {
  let config = sitConfig(tokens) as any

  const agentJFSUserId = RootStore.BillPaymentAgentOnboard.agentJFSUserId || ''
  const CustomerJfsUserId = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId
  const agentLoginId = RootStore.agent.agentInfo?.agentUserLoginId
  // || '1972283249505670348'

  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier
  // config.headers['x-jfsUserId'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  config.headers['x-mobileNumber'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.mobileNumber || ''
  config.headers['x-channelId'] = RootStore.agent.session.CHANNEL_ID || ''

  config.headers['x-channel-user-id'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''

  // config.headers['x-channel-user-id'] = CustomerJfsUserId
  //   ? CustomerJfsUserId
  //   : agentJFSUserId

  // config.headers['x-channel-user-id'] = RootStore.BillPaymentAgentOnboard.tempCustomerData?.jfsUserId || ''
  // config.headers['x-intercept-gateway'] = 'SERVICE/JPB'
  const formatAPIDate = (isoString: string): string => {
    return isoString.slice(0, 19)
  }

  const startDateRaw = getUTCTimeStampp({ daysAgo: 150 })
  const endDateRaw = getUTCTimeStamp()

  // jpbUserId: body?.jpbUserId || '1362601000047036416'|| '1362601000047036416' || '1972283249505670348',

  console.log('Network file getOrtderHistory agentLoginId CustomerJfsUserId', agentLoginId, CustomerJfsUserId)

  const customerDetails = CustomerJfsUserId
    ? {
        jpbUserId: body?.jpbUserId || '',
        agentId: RootStore.agent.agentInfo.agentUserLoginId,
      }
    : {
        agentId: RootStore.agent.agentInfo.agentUserLoginId,
      }

  const requestBody = {
    domain: {
      id: 'PayMyBill',
      name: 'PayMyBill',
      transactionType: 'BUY',
      description: 'Fetch order history',
    },
    customerDetails: customerDetails,
    initiatingEntity: {
      entityId: RootStore.agent.session.CHANNEL_ID || '',
      channelId: RootStore.agent.session.CHANNEL_ID || '',
    },
    config: {
      orderHistoryStartDate: formatAPIDate(startDateRaw),
      orderHistoryEndDate: formatAPIDate(endDateRaw),
      limit: '10',
      offset: '0',
    },
  }

  const request: Request<{}> = {
    apiPath: APIEndPoints.getOrderHistoryBC,
    method: 'POST',
    config: config,
    body: requestBody,
  }

  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })

  return executeRequest(request)
    .then((data) => {
      console.log(data, 'Akanksha see what data we are sending to getFavouriteTransactions response parser')
      console.log('requestBody in getFavouriteTransactions', requestBody)
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
